import { ReportMachine, TravelTimeData } from '../types';

export interface ReportTotals {
  workTime: number;
  travelTime: number;
  travelKm: number;
}

function calcLegMinutes(leg: TravelTimeData['outbound']): number {
  if (!leg || !leg.departureTime || !leg.arrivalTime) return 0;
  const [depH, depM] = leg.departureTime.split(':').map(Number);
  const [arrH, arrM] = leg.arrivalTime.split(':').map(Number);
  let depTotal = depH * 60 + depM;
  let arrTotal = arrH * 60 + arrM;
  if (leg.nextDay) arrTotal += 24 * 60;
  return Math.max(0, arrTotal - depTotal - (leg.breakTime || 0));
}

/** @param technicianCount Multiplies the Travel Time section hours only (both technicians make that trip together); time log travel and km are never multiplied. */
export function calculateReportTotals(
  machines: ReportMachine[] | undefined,
  travelTimeData: TravelTimeData | undefined,
  technicianCount: number = 1
): ReportTotals {
  let workTime = 0;
  let travelTime = 0;
  let travelKm = 0;

  (machines ?? []).forEach(machine => {
    (machine.timeLogs ?? []).forEach(log => {
      if (log.startTime && log.finishTime) {
        const diffMinutes =
          (new Date(log.finishTime).getTime() - new Date(log.startTime).getTime()) / (1000 * 60);
        const breakMinutes = log.breakTime || 0;
        const travelMinutes = log.travelTime || 0;
        workTime += Math.max(0, diffMinutes - breakMinutes - travelMinutes);
      }
      travelTime += log.travelTime || 0;
      travelKm += log.travelKm || 0;
    });
  });

  if (travelTimeData) {
    const mainTravelMinutes = calcLegMinutes(travelTimeData.outbound) + calcLegMinutes(travelTimeData.inbound);
    travelTime += mainTravelMinutes * technicianCount;
    travelKm += travelTimeData.outbound?.km || 0;
    travelKm += travelTimeData.inbound?.km || 0;
  }

  return { workTime, travelTime, travelKm };
}
